function TipoBanner() {

  const dataReturn =  [
    {id: 0, description: '--- Seleziona il tipo di banner'},
    {id: 1, description: 'Banner originale'},
    {id: 2, description: 'Banner classic scroll'},
  ]

  return dataReturn;
} 

export default TipoBanner;

